var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "121px",
    height: "120px",
    viewBox: "0 0 121 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img--userAvatar--placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M120.854657,59.9962124 C120.854652,93.0167225 94.159888,119.823991 61.1396536,119.962882 C28.1194159,120.101775 1.20008167,93.5200172 0.922299563,60.5006724 C0.644519782,27.4813294 27.1128256,0.450440281 60.1307246,0.0337734389 C93.1486238,-0.382893718 120.290622,25.9714644 120.846169,58.9873024",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img--userAvatar--placeholder"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle",
    opacity: 0.98999999,
    x: 1,
    y: 0,
    width: 119.49368,
    height: 119.93546
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "circle",
    stroke: "#000000",
    strokeWidth: 0.06547602,
    fillOpacity: 0.77064221,
    fill: "#DCE4EC",
    opacity: 0.98999999,
    strokeLinecap: "round",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7227106,27.0712164 C72.8186727,26.9186508 82.7619605,36.5735266 82.965404,48.6687449 L82.9685868,49.0383957 C82.9685851,61.1352849 73.189138,70.9560013 61.0923611,71.0069392 C48.9954598,71.0578256 39.1336428,61.3195804 39.0319924,49.2229942 C38.9302416,37.1265121 48.6267688,27.2238748 60.7227106,27.0712164 Z",
    id: "circle-head",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9413132,71.0317796 C79.4703748,70.7854614 95.5239206,86.37332 95.8523823,105.901127 L95.8575209,106.497931 C95.8575182,126.028435 80.0684951,141.884045 60.538118,141.966284 C41.00754,142.048441 25.0855298,126.325982 24.9214141,106.795966 C24.7571364,87.2661186 40.4122844,71.2782475 59.9413132,71.0317796 Z",
    id: "circle-body",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.1011e63f05ae288b459e3854afc23195.svg";
export { ForwardRef as ReactComponent };